import { Component, Input } from '@angular/core';

import { Location } from '@shared';

import { TransportType } from '../models/enums/transport-type.enum';

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
    standalone: false
})
export class MapComponent {
    @Input() public centerLocation: Location;
    @Input() public transport: TransportType;
    @Input() public hidden: boolean;
    @Input() public customClass: string;
    @Input() public set wayPoints(value: Location[]) {
        if (value) {
            return;
        }
    }
}
